import React, { useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ScheduleIcon from '@mui/icons-material/Schedule';
import PrescriptionsIcon from '../assets/icons/prescriptions.png';
import setPageAndDeferNavigate from "../lib/setPageAndDeferNavigate";
import { MinorUserContext } from "../context/UserNameProvider";

import Question from '../components/Question';
import ContinueButton from "../components/ContinueButton";
import InfoCard from "../components/InfoCard";

export default function WhatsNext(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);
    const { isMinor } = useContext(MinorUserContext);

    const handleBack = () => {
        if (user.uberDoc || user.selfPayIntake) {
            setPageAndDeferNavigate(dispatch, '/demographic', navigate);
        } else if (isMinor) {
            setPageAndDeferNavigate(dispatch, '/minor/instructions', navigate);
        } else if (user.payMethod === "self") {
            setPageAndDeferNavigate(dispatch, '/insurance/provider', navigate);
        } else {
            setPageAndDeferNavigate(dispatch, '/insurance/method', navigate);
        }
    };

    return (
        <Question
            onBack={handleBack}
            backgroundColor="#82B1FF33"
            componentHeight="100vh"
            title={"Here's what's next"}
            input={
                <>

                    {user.payMethod === "insurance" ?
                        <>
                            <InfoCard
                                icon={CheckCircleOutlineIcon}
                                title="Tell us about yourself"
                                description="Complete health questionnaire and provide payment details for copay."
                            />

                            <InfoCard
                                icon={ScheduleIcon}
                                title="Treatment plan and appointment"
                                note="Be seen this week"
                                description="A licensed dermatologist drafts a care plan and you finalize it with a nurse practitioner on a call."
                            />

                            <InfoCard
                                icon={PrescriptionsIcon}
                                title="Begin treatment"
                                description="Any prescriptions are sent to your pharmacy. You should start to feel better quickly."
                            />
                        </>
                        :
                        <>
                            <InfoCard
                                icon={CheckCircleOutlineIcon}
                                title="Tell us about yourself"
                                description="Complete health questionnaire and provide payment details."
                            />

                            <InfoCard
                                icon={ScheduleIcon}
                                title="Treatment plan"
                                note="Get a plan within 48 hours"
                                description="A licensed dermatologist sends a plan just for you."
                            />

                            <InfoCard
                                icon={PrescriptionsIcon}
                                title="Begin treatment"
                                description="Any prescriptions are sent to your pharmacy. You should start to feel better quickly."
                            />
                        </>
                    }

                    <ContinueButton
                        sx={{ mt: 2 }}
                        onClick={() => {
                            setPageAndDeferNavigate(dispatch, '/tried-before', navigate);
                        }}
                        title="Continue"
                        selected={true}
                    />
                </>
            }
            {...props}
        />
    );
}
